module.exports = __webpack_public_path__ + "img/lang-zh-hover.72c2e049.png";